class Product {
  constructor() {
    this.acc = [];
    this.container = document.querySelector('.g-main-product');
    GkifyTheme.CompareProduct && GkifyTheme.CompareProduct.setCompareButtonsState();
    GkifyTheme.Wishlist && GkifyTheme.Wishlist.setWishlistButtonsState();
    this.addRecentViewedProduct();

    addEventDelegate({
      context: this.container,
      selector:
        (window.__gkify_review_selector || '') +
        '.g-product-collapsible .jdgm-widget-actions-wrapper, .g-product-collapsible .spr-summary-actions-newreview',
      handler: (e) => {
        const index = e.target.closest('.g-product-collapsible').dataset.index;
        setTimeout(() => {
          this.acc[Number(index)].setContentHeight();
        }, 300);
      },
      capture: true,
    });
  }

  addRecentViewedProduct() {
    const cookies = getCookie('g-recent-viewed-products');
    let products = cookies ? JSON.parse(cookies) : [];
    if (products.indexOf(GkifySettings.productHandle) === -1) {
      products.unshift(GkifySettings.productHandle);
      products = products.slice(0, 20);
      setCookie('g-recent-viewed-products', JSON.stringify(products));
    }
  }
}

// new Product();
